import React from 'react';

export const StripeError = () => <div>Error</div>;
